<template>
  <div>
    <Sidebar :sidebar-items="sidebarItems" />
  </div>
</template>

<script>
import Sidebar from '@/components/sidebars/NavSidebar.vue';

export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      sidebarItems: [
        { title: 'Manage Labor', linkTo: 'labor' },
        { title: 'Manage Material', linkTo: 'material' },
        { title: 'Project Estimates', linkTo: 'project-estimates' },
      ],
    };
  },
};
</script>
